import $ from 'jquery'

const matrices = []

class CoverageMatrix {
    constructor (matrix) {
        this.$matrix = $(matrix)
        this._initSearch()
        this._initButtons()
    }

    _initSearch () {
        const $searchBar = this.$matrix.find('[sw-coverage-matrix-search]').first()

        if ($searchBar.length === 0) {
            this.$searchBar = null
            return
        }

        this.$searchBar = $searchBar.find('input')
        this.$searchBar.on('keyup change', () => this.setFilteredCountries())
    }

    _initButtons () {
        const $buttons = this.$matrix.find('[sw-coverage-matrix-button]')
        $buttons.each((_, button) => {
            const $button = $(button)
            $button.on('click', (e) => {
                e.preventDefault()

                const action = $button.attr('sw-coverage-matrix-button')
                const requestUrl = new URL(
                    `/actions/${action}`,
                    `${window.location.protocol}//${window.location.host}`
                )

                this.getFilteredCountries().forEach((country) => {
                    requestUrl.searchParams.append('countries[]', country)
                })

                window.location.href = requestUrl
            })
        })
    }

    getFilteredCountries () {
        if (this.$searchBar === null || this.$searchBar.val().length === 0) {
            return []
        }

        return this.$matrix.find('tr:not(:first-child):not(.\\+hidden)')
            .map((_, tr) => $(tr).find('td:first-child').text())
            .get()
    }

    setFilteredCountries() {
        const $allRows = this.$matrix.find('tr:not(:first-child)')

        if (this.$searchBar === null || this.$searchBar.val().length === 0) {
            $allRows.removeClass('+hidden')
            return
        }

        const passesFilter = (element) =>
            $(element).find('td:first-child')
                .text()
                .toLowerCase()
                .includes(this.$searchBar.val().toLowerCase())
        $allRows.filter((_, element) => passesFilter(element)).removeClass('+hidden')
        $allRows.filter((_, element) => !passesFilter(element)).addClass('+hidden')
    }
}

export default function coverageSection() {
    $('[sw-coverage-matrix]').each((_, matrix) => {
        matrices.push(new CoverageMatrix(matrix))
    })
}



// WEBPACK FOOTER //
// ./source/scripts/sections/coverage.js